import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    modalCaption: {
      textAlign: 'center',
      paddingTop: '20px',
      paddingBottom: '30px'
    },
    label: {
      width: '100px',
      textAlign: 'left',
      fontSize: 14
    },
    leftAlignContainer: {
      //左寄せ
      display: 'flex',
      alignItems: 'left',
      justifyContent: 'left',
      marginLeft: -3
    },
    radioLabel: {
      textAlign: 'left',
      marginRight: 20
    },
    input: {
      width: '100%'
    },
    itemMargin: {
      margin: '0px 3px'
    },
    textStyle: {
      fontSize: 18
    },
    helperText: {
      color: '#F44336',
      fontSize: '0.75rem',
      position: 'relative',
      top: '-6px',
      marginLeft: '16px',
      marginRight: '16px',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif;'
    },
    gridItem: {
      paddingBottom: 10
    },
    radioContainer: {
      display: 'flex',
      flexFlow: 'column',
      paddingTop: 10
    }
  });
});
